import { IRecipient } from '@tiendanube/common';
import axios from 'App/axios';
import { fetchWithRetry } from '../utils';

const recipientUrl = `v1/pago-nube-onboarding/kyc/recipients/:recipientId`;

const getRecipientWithoutRetry = async (
  document: string,
): Promise<IRecipient> => {
  try {
    const { data } = await axios.get(
      recipientUrl.replace(':recipientId', document),
    );

    return data;
  } catch (error) {
    throw new Error(
      `Failed to fetch recipient: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`,
    );
  }
};

const successConditionFn = (response: IRecipient) => {
  if (response.accounts) {
    return response.accounts[0].status === 'ACTIVE';
  }
  return false;
};

const getRecipientWithRetry = async (storeId: string): Promise<IRecipient> => {
  try {
    const response = await fetchWithRetry(
      getRecipientWithoutRetry,
      [storeId],
      successConditionFn,
      {
        timeoutMs: 5000,
        intervalMs: 500,
      },
    );
    return response;
  } catch (error) {
    throw new Error(
      `Failed to get recipient: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`,
    );
  }
};

const getRecipient = async (
  storeId: string,
  withRetry = false,
): Promise<IRecipient> => {
  if (withRetry) {
    return getRecipientWithRetry(storeId);
  } else {
    return getRecipientWithoutRetry(storeId);
  }
};

const resetRecipientData = () => null;

const updateRecipient = async (
  storeId: string,
  recipient: IRecipient,
): Promise<IRecipient> => {
  try {
    const { data } = await axios.patch(
      recipientUrl.replace(':recipientId', storeId),
      recipient,
    );

    return data;
  } catch (error) {
    throw new Error(
      `Failed to update recipient: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`,
    );
  }
};

export default {
  getRecipient,
  updateRecipient,
  resetRecipientData,
};
